import { useAuth } from '../../shared/hooks/useAuth'

export function UnauthorizedPage() {
  const { signOut, role, user } = useAuth()

  const handleSignOut = async () => {
    await signOut()
    window.location.href = '/'
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card w-full max-w-md p-8 text-center space-y-6">
        <div className="text-6xl mb-4">🚫</div>
        <h1 className="text-3xl font-semibold text-slate-900 mb-2">
          Access Denied
        </h1>
        <div className="text-sm text-slate-600 space-y-2">
          <p>
            You do not have permission to access this page.
          </p>
          {user && (
            <p className="text-xs text-slate-500">
              Logged in as: {user.email}
              {role && <><br />Role: {role}</>}
              {!role && <><br />No role assigned</>}
            </p>
          )}
        </div>
        <button onClick={handleSignOut} className="btn-orange w-full">
          Sign out
        </button>
      </div>
    </div>
  )
}
